import { Platform } from '@/constants';
import { dateFormatInUserTimeZone } from '@/helpers';
import { AbstractModel } from '@/models/abstractModel';
import type { IPageVisitHistoryRow } from '@/types/pageVisitHistory';

const PAGE_VISIT_HISTORY_DATE_FORMAT = 'dd-MMM HH:mm:ss';

export class PageVisitHistoryItem extends AbstractModel {
    public count: number;
    public createdAt: string;
    public hasExpandedContent: boolean;
    public id: number;
    public isTradeballUser: boolean;
    public modifiedAt: string;
    public pageId: number;
    public post: string | null;
    public query: string | null;
    public sessionId: string | null;
    public sourceId: number;
    public uniqAppId: string;
    public url: string;
    public userAgent: string;
    public userId: number;
    public userIp: string;
    public userName: string;
    public userPlatformId: number;

    constructor(data: IPageVisitHistoryRow) {
        super();
        this.id = data.id;
        this.createdAt = data.created_at;
        this.modifiedAt = data.modified_at;
        this.userId = data.user_id;
        this.userIp = data.user_ip;
        this.userAgent = data.user_agent;
        this.sessionId = data.session_id;
        this.uniqAppId = data.uniq_app_id;
        this.pageId = data.page_id;
        this.count = data.count;
        this.url = data.url;
        this.query = data.query;
        this.post = data.post;
        this.sourceId = data.source_id;
        this.userName = data.user_name;
        this.userPlatformId = data.user_platform_id;
        this.isTradeballUser = data.user_platform_id === Platform.Tradeball;
        this.hasExpandedContent = !!(this.query || this.post);
    }

    get formatCreatedDate(): string {
        return dateFormatInUserTimeZone(this.createdAt, PAGE_VISIT_HISTORY_DATE_FORMAT);
    }

    get formatModifiedDate(): string {
        return dateFormatInUserTimeZone(this.modifiedAt, PAGE_VISIT_HISTORY_DATE_FORMAT);
    }

    get urlMethodBadge(): 'get' | 'post' {
        if (this.post) return 'post';
        return 'get';
    }
}
